import { Guid } from "guid-typescript";
import { all, put, takeLatest, call, select } from "redux-saga/effects";

import { HttpStatusCodes } from "infrastructure/http";
import { commonMessages } from "infrastructure/localization";
import { notification } from "infrastructure/notification";
import { extractApiErrorMessage } from "ui/shared/models/common";

import { releaseMessages } from "../release.localization";

import { createReleaseActions } from "./CreateRelease.actions";
import * as api from "./CreateRelease.api";
import { IReleaseState } from "./CreateRelease.state";

function* addReleaseExecute() {
  const release: IReleaseState = yield select((state: { createRelease: IReleaseState }) => state.createRelease);
  try {
    yield call(api.addRelease, {
      releaseId: Guid.raw(),
      name: release.releaseName
    });

    yield call(api.refreshMessageCache);
    yield put(createReleaseActions.addReleaseCompleted(notification.success().useMessageId(releaseMessages.info("addReleaseCompleted"))));
  } catch (error) {
    yield put(
      createReleaseActions.addReleaseFailed(
        error.statusCode === HttpStatusCodes.BadRequest
          ? notification.error(error).useMessage(extractApiErrorMessage(error.data).localizable)
          : notification.error(error).useMessageId(commonMessages.error("unexpectedError"))
      )
    );
  }
}

function* actionWatcher() {
  yield takeLatest(createReleaseActions.addRelease.toString(), addReleaseExecute);
}

export function* createReleaseSaga() {
  yield all([actionWatcher()]);
}
